/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Input_Position_Y_Move_UpInputs */



/**
* | output |
* | --- |
* | "Move Up 1 Line" |
*
* @param {Input_Position_Y_Move_UpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const input_position_y_move_up = /** @type {((inputs?: Input_Position_Y_Move_UpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Input_Position_Y_Move_UpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Déplacer Vers le Haut de 1 Ligne")
	if (locale === "de") return /** @type {LocalizedString} */ ("Eine Zeile nach oben rücken")
	if (locale === "it") return /** @type {LocalizedString} */ ("Spostati di 1 riga in su")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Переместиться на 1 строку вверх")
	if (locale === "es") return /** @type {LocalizedString} */ ("Subir 1 línea")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("向上移动一行")
	if (locale === "ja") return /** @type {LocalizedString} */ ("1行上に移動")
	if (locale === "hi") return /** @type {LocalizedString} */ ("एक पंक्ति ऊपर जाएं")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Subir uma linha")
	return /** @type {LocalizedString} */ ("Move Up 1 Line")
});